/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */
import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';
import { DeliveryEmployeeSelectableResourceService } from './delivery-employee-selectable-resource.service';

export const dispatcherSelectableResourceProviders = [
  {
    provide: SelectableResourceService,
    useClass: DeliveryEmployeeSelectableResourceService,
    multi: true,
  }
];
